<template>
  <div style="margin: 0 auto; display: inline-block;">
    <lottie-vue-player
      :src="`/animations/search-loader.json`"
      :autoplay="true"
      :loop="true"
      style="width: 80px; height:80px"
    >
    </lottie-vue-player>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      options: {},
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Loading.vue